var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark24X24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1862 12.4193C19.5071 11.97 20.1313 11.8655 20.5807 12.1862C21.03 12.5071 21.1345 13.1313 20.8138 13.5807L15.8138 20.5807C15.6429 20.8199 15.375 20.9718 15.082 20.9961C14.7892 21.0202 14.5007 20.9148 14.293 20.707L11.293 17.707L11.224 17.6315C10.9035 17.2387 10.9268 16.6591 11.293 16.293C11.6591 15.9268 12.2387 15.9035 12.6315 16.224L12.707 16.293L14.8724 18.4583L19.1862 12.4193Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3ZM16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark24X24);
export default __webpack_public_path__ + "static/media/checkmark-24x24.2bffe2b12e5cf2b3234a856d93e3c530.svg";
export { ForwardRef as ReactComponent };